document.body.classList.add('ds-studio-page');


(function () {
  'use strict';

  const root = document.querySelector('[data-darussalam-root]');
  if (!root) return;

  /* ───────────────── CUSTOM CURSOR ───────────────── */
  const cursor = document.getElementById('dsCursor');
  const ring = document.getElementById('dsCursorRing');

  if (cursor && ring && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    let mx = window.innerWidth / 2;
    let my = window.innerHeight / 2;
    let rx = mx, ry = my;

    document.addEventListener('mousemove', (e) => {
      mx = e.clientX;
      my = e.clientY;
    });

    function animateCursor() {
      cursor.style.left = mx + 'px';
      cursor.style.top = my + 'px';
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top = ry + 'px';
      requestAnimationFrame(animateCursor);
    }
    animateCursor();

    function bindHoverTargets() {
      root.querySelectorAll('a, button, .ds-package-card, .ds-feature-tile').forEach((el) => {
        if (el.dataset.dsCursorBound === '1') return;
        el.dataset.dsCursorBound = '1';
        el.addEventListener('mouseenter', () => {
          cursor.style.width = '6px';
          cursor.style.height = '6px';
          ring.style.width = '52px';
          ring.style.height = '52px';
        });
        el.addEventListener('mouseleave', () => {
          cursor.style.width = '12px';
          cursor.style.height = '12px';
          ring.style.width = '36px';
          ring.style.height = '36px';
        });
      });
    }
    bindHoverTargets();
  }

  /* ───────────────── HAMBURGER MENU ───────────────── */
  const toggle = document.getElementById('dsNavToggle');
  const navLinks = document.getElementById('dsNavLinks');

  if (toggle && navLinks) {
    toggle.addEventListener('click', () => {
      const isOpen = navLinks.classList.toggle('is-open');
      toggle.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    // Close menu when any nav link is clicked
    navLinks.querySelectorAll('[data-ds-link]').forEach((link) => {
      link.addEventListener('click', () => {
        navLinks.classList.remove('is-open');
        toggle.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!toggle.contains(e.target) && !navLinks.contains(e.target)) {
        navLinks.classList.remove('is-open');
        toggle.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ───────────────── SMOOTH SCROLL NAV ───────────────── */
  const allNavLinks = root.querySelectorAll('[data-ds-link]');

  function smoothScrollTo(id) {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  root.addEventListener('click', (e) => {
    const link = e.target.closest('[data-ds-link]');
    if (!link) return;
    const target = link.dataset.dsLink;
    if (!target) return;
    e.preventDefault();
    const newHash = '#' + target;
    if (window.location.hash !== newHash) {
      history.pushState({ dsSection: target }, '', newHash);
    }
    smoothScrollTo(target);
  });

  window.addEventListener('popstate', () => {
    const name = (window.location.hash || '#home').replace('#', '');
    smoothScrollTo(name);
  });

  // Jump to hash on load
  const initial = (window.location.hash || '').replace('#', '');
  if (initial) setTimeout(() => smoothScrollTo(initial), 100);

  /* ───────────────── SCROLL SPY ───────────────── */
  function setActiveLink(name) {
    allNavLinks.forEach((link) => {
      link.classList.toggle('is-active', link.dataset.dsLink === name);
    });
  }

  const sections = root.querySelectorAll('[data-ds-section]');
  const spy = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const name = entry.target.dataset.dsSection;
        setActiveLink(name);
        const newHash = '#' + name;
        if (window.location.hash !== newHash) {
          history.replaceState({ dsSection: name }, '', newHash);
        }
      }
    });
  }, { rootMargin: '-40% 0px -55% 0px', threshold: 0 });

  sections.forEach((sec) => spy.observe(sec));
  if (!initial) setActiveLink('home');

  /* ───────────────── REVEAL ANIMATIONS ───────────────── */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('is-visible'), entry.target.dataset.delay || 0);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  root.querySelectorAll('.ds-why-feature, .ds-package-card, .ds-feature-tile, .ds-step, .ds-strip-item')
    .forEach((el, i) => {
      el.dataset.delay = (i % 4) * 100;
      io.observe(el);
    });

  root.querySelectorAll('.ds-package-card').forEach((card, i) => {
    card.style.transitionDelay = (i * 0.15) + 's';
  });

  /* ───────────────── GALLERY TABS ───────────────── */
  root.querySelectorAll('[data-ds-gallery]').forEach((gallery) => {
    const tabs = gallery.querySelectorAll('[data-ds-tab]');
    const slides = gallery.querySelectorAll('[data-ds-slide]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.dsTab;
        tabs.forEach((t) => {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        slides.forEach((slide) => {
          slide.classList.toggle('is-active', slide.dataset.dsSlide === target);
        });
      });
    });
  });

})();